import { useState } from 'react';
const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [files, setFiles] = useState(null);
  const [docTypes, setDocTypes] = useState([]);

  return {
    loading,
    setLoading,
    loadingDocs,
    setLoadingDocs,
    files,
    setFiles,
    docTypes,
    setDocTypes,
  };
};

export default useCustomHook;
